module.exports = __webpack_public_path__ + "static/media/DSC00721-32_Small.b6debb49.jpg";